import { Box, Inspector, List } from '@bynder/design-system';
import { ReactElement, useState } from 'react';
import { IconArrowDown } from '@bynder/icons';
import { ListArrow } from '../Styles';

interface AccordionProps {
  title: string;
  subtext?: string;
  children: React.ReactNode;
  noDivider?: boolean;
  isDisabled?: boolean;
  expanded?: boolean;
  thumbnail?: ReactElement;
  divider?: boolean;
}

export const SettingsAccordion: React.FC<AccordionProps> = ({
  title,
  subtext,
  children,
  noDivider = false,
  isDisabled = false,
  expanded = true,
  thumbnail,
}) => {
  const [isExpanded, setIsExpanded] = useState(expanded);

  return (
    <>
      <List.Item
        thumbnail={thumbnail}
        isDisabled={isDisabled}
        rightElements={
          <ListArrow aria-label="Toggle" rotate={isExpanded ? 180 : 0}>
            <IconArrowDown />
          </ListArrow>
        }
        subtext={subtext}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {title}
      </List.Item>
      {isExpanded && <Box paddingTop="3">{children}</Box>}
      {!noDivider && <Inspector.Divider />}
    </>
  );
};
